import { type AlertActivityType } from '@/api/types/Alert'
import Avatar from '@/elements/Avatar'
import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import Timestamp from '@/elements/Timestamp'
import useAlertActivity from '@/hooks/useAlertActivity'

const AlertActivity = ({
  activity
}: {
  activity: AlertActivityType
}) => {
  const { activityCreator, activityMessage } = useAlertActivity(activity)

  return (
    <Flex inline gap={2}>
      <Avatar
        name={activityCreator?.details.fullName}
        size='small'
        src={activityCreator?.assets?.PROFILE_PICTURE || ''}
      />
      <Flex gap={1}>
        <Timestamp from={activity.createdAt ?? ''} noIcon />
        <Text variant='textblock' color='black-light-20'>
          {activityMessage}
        </Text>
      </Flex>
    </Flex>
  )
}

export default AlertActivity
